(() => {
  const elementName = 'cc-t10-music-organized-carousel';

  if (customElements.get(elementName)) return;

  class CcT10MusicOrganizedCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      this.controller = new AbortController();
      this.image = this.querySelector('.cc-t10-music-organized__image');
      this.previousButton = this.querySelector('[data-cc-t10-music-organized-previous]');
      this.nextButton = this.querySelector('[data-cc-t10-music-organized-next]');
      this.dots = [...this.querySelectorAll('[data-cc-t10-music-organized-dot]')];
      this.sourceTemplate = this.querySelector('[data-cc-t10-music-organized-sources]');
      this.sources = this.sourceTemplate?.content.textContent.trim().split('|').map((source) => {
        const [mobile, desktop] = source.trim().split('~');
        return { mobile, desktop };
      }).filter((source) => source.mobile && source.desktop) || [];
      this.activeIndex = 0;

      if (!this.image || this.sources.length !== 3 || !this.previousButton || !this.nextButton || this.dots.length !== 3) return;

      this.previousButton.addEventListener('click', () => this.setActive(this.activeIndex - 1), { signal: this.controller.signal });
      this.nextButton.addEventListener('click', () => this.setActive(this.activeIndex + 1), { signal: this.controller.signal });
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.setActive(index), { signal: this.controller.signal }));
      this.addEventListener('keydown', this.handleKeydown, { signal: this.controller.signal });
      this.preloadWhenNearViewport();
      this.syncControls();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.preloadObserver?.disconnect();
      this.controller = null;
      this.preloadObserver = null;
    }

    handleKeydown = (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.setActive(this.activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.setActive(this.activeIndex + 1);
      }
    };

    setActive(index) {
      const normalizedIndex = (index + this.sources.length) % this.sources.length;
      if (normalizedIndex === this.activeIndex) return;
      this.activeIndex = normalizedIndex;
      this.image.removeAttribute('srcset');
      this.image.src = this.sourceForViewport(this.sources[normalizedIndex]);
      this.syncControls();
    }

    syncControls() {
      this.previousButton.disabled = false;
      this.nextButton.disabled = false;
      this.dots.forEach((dot, index) => {
        if (index === this.activeIndex) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    preloadWhenNearViewport() {
      const preload = () => {
        this.sources.slice(1).forEach((source) => {
          const image = new Image();
          image.src = this.sourceForViewport(source);
        });
      };

      if (!('IntersectionObserver' in window)) return;
      this.preloadObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        preload();
        this.preloadObserver.disconnect();
      }, { rootMargin: '600px 0px' });
      this.preloadObserver.observe(this);
    }

    sourceForViewport(source) {
      return window.matchMedia('(max-width: 768px)').matches ? source.mobile : source.desktop;
    }
  }

  customElements.define(elementName, CcT10MusicOrganizedCarousel);
})();
